import React, { useState, useEffect, useRef } from "react";
import { Box, Checkbox, CircularProgress, LinearProgress, Typography } from "@mui/material";
import Button from "../../components/inputs/Button";
import Textfield from "../../components/inputs/Textfield";
import MobileTopBar from "../../components/navigation/MobileTopBar";
import ProfileIcon from "../../components/icons/ProfileIcon";
import PasswordIcon from "../../components/icons/PasswordIcon";
import api from "../../components/api";

const Home = ({ setState, mobile, setLoggedIn, setLoggedInUser }) => {
  const [user, setUser] = useState("");
  const userRef = useRef();
  const [password, setPassword] = useState("");
  const passwordRef = useRef();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const logIn = async () => {
    setLoading(true);
    setError(false);
    await api.authUser(
      user,
      password,
      (response) => {
        localStorage.setItem("fullpass_user", JSON.stringify(response));
        setLoading(false);
        if (response.subscriptionStatus == "INACTIVE") {
          setState(4);
        } else if (response.subscriptionStatus == "AWAITING_PAYMENT") {
          setState(6);
        } else {
          setLoggedIn(1);
          setLoggedInUser(response);
        }
      },
      (error) => {
        console.log(error);
        setError(error.data);
        setLoading(false);
      }
    );
  };

  const handleKeyDown = (event, nextRef) => {
    if (event.key === "Enter") {
      event.preventDefault();
      nextRef.current.focus();
    }
  };

  return (
    <>
      {!mobile && (
        <Typography
          style={{
            fontWeight: "bold",
            fontSize: "40px",
            color: "white",
            textAlign: "center",
            lineHeight: "1.2",
            marginBottom: "20px",
          }}
        >
          Ingresá a tu cuenta
        </Typography>
      )}
      {mobile > 0 && (
        <MobileTopBar onBack={() => setState(0)} showBack>
          Ingresá a tu cuenta
        </MobileTopBar>
      )}
      {mobile > 0 && (
        <div
          style={{
            width: "500px",
            maxWidth: "80vw",
            marginBottom: "30px",
          }}
        >
          <img src="img/icon.png" style={{ width: "100%", height: "auto", objectFit: "contain" }} />
        </div>
      )}
      <Textfield
        hint="Email o DNI"
        startIcon={<ProfileIcon />}
        onChange={(e) => setUser(e)}
        disabled={loading}
        error={error}
        inputRef={userRef}
        onKeyDown={(e) => handleKeyDown(e, passwordRef)}
      ></Textfield>
      <Textfield
        hint="Contraseña"
        startIcon={<PasswordIcon />}
        passwordMode={true}
        onChange={(e) => setPassword(e)}
        disabled={loading}
        error={error}
        inputRef={passwordRef}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            passwordRef.current.blur();
            !loading && logIn();
          }
        }}
      ></Textfield>
      {error && (
        <Typography
          style={{
            fontWeight: "400",
            fontSize: "18px",
            color: "#FF1F01",
            textAlign: "center",
            lineHeight: "1.2",
            //opacity: loading ? 0.5 : 1,
          }}
        >
          Credenciales incorrectas
        </Typography>
      )}
      <Typography
        style={{
          fontWeight: "400",
          fontSize: "18px",
          color: "white",
          textAlign: "center",
          lineHeight: "1.2",
          //opacity: loading ? 0.5 : 1,
        }}
      >
        ¿Olvidaste tu contraseña?{" "}
        <span style={{ fontWeight: "500", color: "#FF9700", cursor: loading ? "default" : "pointer" }}>Click acá</span>
      </Typography>
      <Button onClick={!loading ? logIn : undefined} loading={loading}>
        Ingresar
      </Button>

      {/*loading && (
        <LinearProgress
          sx={{
            width: "100%",
            backgroundColor: "#181A20", // Color de fondo de la barra vacía
            "& .MuiLinearProgresss-bar": {
              backgroundColor: "#FF9700", // Color de la barra de progreso
            },
          }}
        />
      )*/}
      <Typography
        style={{
          fontWeight: "400",
          fontSize: "18px",
          color: "#FF9700",
          textAlign: "center",
          lineHeight: "1.2",
          cursor: loading ? "default" : "pointer",
          //opacity: loading ? 0.5 : 1,
        }}
        onClick={!loading ? () => setState(2) : undefined}
      >
        Registrarse <span style={{ fontWeight: "500", color: "white" }}></span>
      </Typography>
    </>
  );
};

export default Home;
